require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wob-decoding-indias-labour-codes.json") })
        }
      }, "path---wob-decoding-indias-labour-codes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wob-decoding-indias-labour-codes!./.cache/json/wob-decoding-indias-labour-codes.json
// module id = 1283
// module chunks = 231608221292675